// ** Icons Import
// import { Heart } from 'react-feather'

// ** Config
import themeConfig from '@configs/themeConfig'

const Footer = () => {
    return (
        <p className="clearfix mb-0">
            <span className="float-md-start d-block d-md-inline-block mt-25">
                COPYRIGHT © 2009-{new Date().getFullYear()}{' '}
                <a href="https://mu-hanoi.net" target="_blank" rel="noopener noreferrer">
                    {themeConfig.app.appAuthor} | {themeConfig.app.appName}
                </a>
                {/* <span className="d-none d-sm-inline-block">, All rights Reserved</span> */}
            </span>
            <span className="float-md-end d-none d-md-block">
                {/* lizbzlx */}
                {/* <Heart size={14} /> */}
            </span>
        </p>
    )
}

export default Footer
